import React from 'react';
import { useLocale } from '../../contexts/LocaleContext';
import { getPlayStoreBadgeUrl, PLAY_STORE_URL } from './install-apps-constants';

interface GooglePlayBadgeProps {
  onClick?: () => void;
  height?: number;
  className?: string;
}

export const GooglePlayBadge: React.FC<GooglePlayBadgeProps> = ({
  onClick,
  height = 48,
  className,
}) => {
  const { t, locale } = useLocale();

  return (
    <a
      href={PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      aria-label={t('landing_apps_android_cta')}
      className={className}
    >
      <img
        src={getPlayStoreBadgeUrl(locale)}
        alt={t('landing_apps_android_cta')}
        style={{ height: `${height}px`, width: 'auto' }}
      />
    </a>
  );
};
